import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import SEO from "./components/SEO";
function Blog() {
  return (
     <>
      <SEO
        title="The Rolo Blog | Travel Tips, Mobility Tech & Safety Hacks"
        description="Read the latest articles on road safety, smart vehicle utility hacks, Pune weekend getaway guides, and the tech behind seamless intercity travel."
        keywords="Rolo blog, travel tips India, Pune weekend road trips, car safety hacks, mobility technology blog, smart vehicle ownership"
        url="https://rolotransit.com/blog"
      />

   

      {/* page content */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#000", // 🔥 ADD THIS
        color: "#fff"
      }}
    >
      <Navbar />

      <div style={{ flex: 1 }}>
        <iframe
  src="/rolo_blog.html"
  style={{
    width: "100%",
    height: "100vh",
    border: "none",
    overflow: "hidden"
  }}

/>
      </div>

      <Footer />
    </div>
    </>
  );
}

export default Blog;

